import React from 'react';
import {
  Bars3Icon,
  XMarkIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';

const initials = (name) =>
  String(name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w.charAt(0))
    .join('')
    .toLocaleUpperCase('tr-TR') || '–';

const handleLogout = () => {
  localStorage.removeItem('username');
  localStorage.removeItem('role');
  localStorage.removeItem('company');
  window.location.href = '/';
};

const AppHeader = ({ kurumAd, logo, rname, onToggleSidebar, menuExpanded, showClose }) => (
  <header className="app-header">
    <button
      type="button"
      className="icon-button app-header__menu"
      onClick={onToggleSidebar}
      aria-label={menuExpanded ? 'Menüyü daralt' : 'Menüyü aç'}
      aria-expanded={menuExpanded}
      title={menuExpanded ? 'Menüyü daralt' : 'Menüyü aç'}
    >
      {showClose ? <XMarkIcon /> : <Bars3Icon />}
    </button>

    <div className="app-header__brand">
      {logo && <img src={logo} alt="" className="app-header__logo" />}
      <span className="app-header__title">{kurumAd || 'İDEKOD'}</span>
    </div>

    <div className="app-header__actions">
      <div className="app-header__user">
        <span className="app-header__avatar" aria-hidden="true">{initials(rname)}</span>
        <span className="app-header__name">{rname}</span>
      </div>

      <button
        type="button"
        onClick={handleLogout}
        className="icon-button"
        aria-label="Çıkış yap"
        title="Çıkış Yap"
      >
        <ArrowRightOnRectangleIcon />
      </button>
    </div>
  </header>
);

export default AppHeader;
